import INFO_01 from '../../../assets/images/feature/feature-agreement-01.png';
import INFO_02 from '../../../assets/images/feature/feature-agreement-02.png';

export default [
  {
    source: INFO_01,
    alt: '개인정보 확인',
    title: '왜 개인정보를 확인하나요?',
    subTitle:
      '조건 산출을 위해 이름, 주민등록번호, 직장 정보 등 개인정보 동의를 받아 금융사에 전달해요',
  },
  {
    source: INFO_02,
    alt: '본인인증 확인',
    title: '왜 본인인증이 필요한가요?',
    subTitle: '본인이 대출을 진행하는지 확인하기 위해 필요해요',
  },
];
